import React, { useState, ChangeEvent, useEffect } from 'react';

import { Row, Column } from 'components/Layout/Grid';
import { Visibility } from 'components/Visibility';
import { Button } from 'components/Button';
import Text from 'components/Text';
import Form from 'components/Form';

import IconSearch from 'img/search-icon.svg';

import { CteTableSearchProps } from './interface';
import { calcDataFrom, calcDataTo, getMaxDateInSearchFilter, getMinDateInSearchFilter } from 'utils/Date';
import { addKeyPressListener, removeKeyPressListener } from 'utils/searchWithEnterPress';
import { DateOutputStr } from 'utils/DateOutput';
import { fastFilters } from './models';
import PeriodDateToInput from 'components/PeriodDateToInput';

export const CteTableSearch: React.FC<CteTableSearchProps> = (props) => {
  const {
    placeholder,
    setTableFilter,
    dateKey,
    tableOrderBy,
    setTableOrderBy,
    className,
    setCurrentPage,
    showFastFilters = true
  } = props;

  const randomTableSearchId = `${Math.random() * 1000}`;
  const [searchStr, setSearchStr] = useState('');

  const [newData, setNewData] = useState('');
  const [period, setPeriod] = useState({
    from: getMinDateInSearchFilter() ? DateOutputStr(getMinDateInSearchFilter().toISOString(), 'yyyy-MM-dd') : '',
    to: getMaxDateInSearchFilter() ? DateOutputStr(getMaxDateInSearchFilter().toISOString(), 'yyyy-MM-dd') : '',
  });

  useEffect(() => {
    addKeyPressListener(randomTableSearchId, makeFilter);

    return () => {
      removeKeyPressListener(randomTableSearchId, makeFilter);
    };
  }, []);

  const makeFilter = () => {
    const newFilter = {
      documentEbl: searchStr,
      startPeriod: period.from ? `${period.from}T00:00:00.000Z` : "",
      lastPeriod: period.to ? `${period.to}T23:59:59.999Z` : "",
    };

    setCurrentPage(0);
    setTableFilter(newFilter);
  };

  function setFastFilter(value: any) {
    if (tableOrderBy === value) return;

    setTableOrderBy(value);
  }

  const fastSearchStyles = (filter: any) =>
    `${tableOrderBy === filter.value && 'border-bottom-2'} font-bold ${tableOrderBy === filter.value ? 'color-primary' : 'color-dark-gray'}`;

  const handleDateFirst = (e: ChangeEvent<HTMLInputElement>) => {
    setPeriod({ ...period, from: e.target.value });
    setNewData('end');
  };

  return (
    <Form id="table-search-cte" onValidate={makeFilter}>
      <Row
        id={randomTableSearchId}
        tabIndex={0}
        className={`mt-4 align-center flex-md-column align-md-none flex-wrap justify-md-none bg-white ${className || 'px-3 py-3'}`}
        style={{ borderRadius: '10px 10px 0px 0px' }}
      >
        <Column className="mr-2 mr-md-2 w-md-100 ajustment-filter">
          <Text className="mb-1 color-blue-gray" size={12} weight="bold">
            Filtro
          </Text>

          <Row>
            <input
              onChange={(e) => setSearchStr(e.target.value)}
              type="text"
              placeholder={placeholder}
              value={searchStr}
              className="w-sm-100 w-md-100"
            />
          </Row>

        </Column>
        <Visibility visible={!!dateKey}>
          <Column className="flex-1 mr-2 mr-md-2 w-md-100 mt-md-3">
            <Text className="mr-2 mb-1 color-blue-gray" size={12} weight="bold">
              Período
            </Text>
            <Row className="flex-1 align-center">
              <input
                className="flex-1"
                value={period.from}
                onChange={handleDateFirst}
                type="date"
                max={period.to}
                placeholder="Início"
                onBlur={() => calcDataTo(period, newData, setPeriod)}
              />
              <Text className="mx-1 color-blue-gray" size={12} weight="bold">
                a
              </Text>
              <PeriodDateToInput
                setNewData={setNewData}
                onBlur={() => calcDataFrom(period, newData, setPeriod)}
                className="flex-1"
                period={period}
                setPeriod={setPeriod}
                placeHolder={"Fim"}
              />
            </Row>
          </Column>
        </Visibility>

        <Column className="mr-2 mt-md-3 w-md-100 pt-3 pt-md-0 ajustment-button">
          <Row>
            <Button
              id="btn_table_search_cte"
              tabIndex={0}
              className="focus-button"
              width="auto"
              onClick={() => makeFilter()}
            >
              <img src={IconSearch} alt="" />
            </Button>
          </Row>
        </Column>

        <Row className="mt-3 mt-md-3 align-center justify-between flex-1 w-md-100 flex-md-column">
          <Visibility visible={showFastFilters}>
            <Row className="align-center flex-1 justify-start justify-md-center w-md-100 align-md-none">
              {fastFilters?.map((filter, index) => (
                <Button
                  key={index}
                  className={`${index > 0 && 'ml-0 ml-md-0'}`}
                  onClick={() => setFastFilter(filter.value)}
                  width="auto"
                >
                  <Text
                    size={12}
                    className={`border-primary ${fastSearchStyles(filter)} pb-1 px-2 ajustment-fontsize-fast-filter`}
                  >
                    {filter.label}
                  </Text>
                </Button>
              ))}
            </Row>
          </Visibility>
        </Row>
      </Row>
    </Form>
  );
};